const MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December'
];

function ordinal(day) {
	if (day >= 11 && day <= 13) return `${day}th`;
	const suffix = { 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] ?? 'th';
	return `${day}${suffix}`;
}

// Parses the YYYY-MM-DD parts directly so the day never shifts with the server's timezone.
export function formatDisplayDate(isoDate) {
	const parts = /^(\d{4})-(\d{2})-(\d{2})$/.exec(isoDate ?? '');
	if (!parts) return '';
	const month = MONTHS[Number(parts[2]) - 1];
	return month ? `${month} ${ordinal(Number(parts[3]))}` : '';
}

export function defaultClosedMessage(decisionDate) {
	const formatted = formatDisplayDate(decisionDate);
	return `We will be in contact via email to communicate if your application has been accepted or denied${formatted ? ` by ${formatted}` : ''}. If your application has been accepted, an email will be sent with distribution/pickup details.`;
}
